function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c5c5c5;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M60.555,18.162l-1.54-2.568a7.627,7.627,0,0,1-1.087-3.924V9.421A6.288,6.288,0,0,0,53.441,3.4V1.794a1.794,1.794,0,1,0-3.589,0V3.4a6.288,6.288,0,0,0-4.486,6.016V11.67a7.632,7.632,0,0,1-1.087,3.923l-1.54,2.568a.449.449,0,0,0,.384.68H60.17a.448.448,0,0,0,.385-.679Z",
  transform: "translate(-42.675 0)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.146 19.738)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M188.815,469.333a3.121,3.121,0,0,0,5.651,0Z",
  transform: "translate(-188.815 -469.333)"
}));

const SvgIconNotification = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.943,
    height: 21.533,
    viewBox: "0 0 17.943 21.533",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Notification.12e7242b.svg";
export { ForwardRef as ReactComponent };